module.exports = __webpack_public_path__ + "static/media/BarkerPawLogo.ca1c0f57.png";